module.exports = __webpack_public_path__ + "media/images/shop-db53c8f1b581d983ebbabb202c189b07.svg";